import { TempZone } from "~/lib/tempZone";
import {
  CompleteCountingTaskRequest,
  CycleCountFilterCountsResponse,
  IncompleteCycleCountsResponse,
  SetCycleCountFrequencyRequest,
  StartCycleCountingRequestDto
} from "~/types/api";

import { warehouseApi } from "./warehouseApi";

export const cycleCountsOverhaulApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    getOverhaulIncompleteCycleCounts: build.query<
      IncompleteCycleCountsResponse,
      {
        limit?: number;
        offset?: number;
        gridId?: Guid;
        AutoStoreBins: boolean;
        variantId?: Guid;
        temperatureZones?: TempZone[];
      }
    >({
      query: ({
        limit,
        offset,
        gridId,
        AutoStoreBins,
        variantId,
        temperatureZones
      }) => {
        return {
          url: "/cycle-counts-overhaul/incomplete-cycle-counts",
          params: {
            limit,
            offset,
            gridId,
            AutoStoreBins,
            variantId,
            temperatureZones
          }
        };
      },
      providesTags: ["cycle count data"]
    }),
    getCycleCountFilterCounts: build.query<
      CycleCountFilterCountsResponse,
      {
        gridId: Guid;
        variantId?: Guid;
      }
    >({
      query: ({ gridId, variantId }) => ({
        url: "/cycle-counts-overhaul/filters",
        params: {
          autoStoreBins: true,
          gridId,
          variantId
        }
      }),
      providesTags: ["cycle count data"]
    }),
    postStartCycleCounting: build.mutation<
      void,
      {
        cycleCountIds: Guid[] | undefined;
        gridId: Guid | undefined;
        workstationId: Guid | undefined;
      }
    >({
      query: ({ cycleCountIds, gridId, workstationId }) => {
        const request: StartCycleCountingRequestDto = {
          cycleCountIds: cycleCountIds ?? []
        };

        return {
          url: `/autostore-grid/${gridId}/workstation/${workstationId}/start-cycle-counting`,
          method: "POST",
          body: request
        };
      }
    }),
    postCompleteCountingTask: build.mutation<void, CompleteCountingTaskRequest>(
      {
        query: ({
          cycleCountId,
          inventoryId,
          actualCount,
          actualExpiration,
          actualManufactureDate,
          autostoreGridId,
          autostorePortId,
          workstationId,
          reasonCode
        }) => {
          return {
            url: `/cycle-counts-overhaul/complete-counting-task`,
            method: "POST",
            body: {
              CycleCountId: cycleCountId,
              InventoryId: inventoryId,
              ActualCount: actualCount,
              ActualExpiration: actualExpiration,
              ActualManufactureDate: actualManufactureDate,
              AutostoreGridId: autostoreGridId,
              AutostorePortId: autostorePortId,
              WorkstationId: workstationId,
              ...(reasonCode && { ReasonCode: reasonCode })
            }
          };
        }
      }
    ),
    putCycleCountFrequency: build.mutation<
      void,
      {
        variantId: Guid;
        frequency: number;
        workstationId?: Guid;
      }
    >({
      query: ({ variantId, frequency, workstationId }) => {
        const args: SetCycleCountFrequencyRequest = {
          variantId,
          frequency,
          ...(workstationId && { workstationId })
        };
        return {
          url: `/cycle-counts-overhaul/set-frequency`,
          method: "PUT",
          body: args
        };
      }
    })
  }),
  overrideExisting: false
});
